/* AimGrips Header — sticky (fixed + spacer), mobile menu, dropdowns, announcement rotation */
(function () {
  'use strict';

  function initHeader(root) {
    if (root.dataset.aghInit === 'true') return;
    root.dataset.aghInit = 'true';

    var host = root.closest('[data-agh-host]') || root.parentElement;
    var header = root.querySelector('[data-agh-header]');
    var burger = root.querySelector('[data-agh-burger]');
    var mobile = root.querySelector('[data-agh-mobile]');
    var overlay = root.querySelector('[data-agh-overlay]');
    var spacer = host ? host.querySelector('[data-agh-spacer]') : null;

    function isMenuOpen() { return mobile && mobile.classList.contains('is-open'); }

    /* ---------- Sticky: fixed header + auto-sized spacer ---------- */
    if (header) {
      var sticky = header.getAttribute('data-sticky') !== 'false';
      var hideOnDown = header.getAttribute('data-hide-on-scroll') !== 'false';
      var transparent = header.getAttribute('data-transparent') === 'true';

      function sizeSpacer() {
        if (!spacer) return;
        /* When transparent-over-hero, the header overlays the first section (no spacer). */
        spacer.style.height = transparent ? '0px' : root.offsetHeight + 'px';
      }

      if (sticky) {
        root.classList.add('agh-fixed');
        sizeSpacer();
        window.addEventListener('load', sizeSpacer);
        window.addEventListener('resize', sizeSpacer);
        if (window.ResizeObserver) {
          try { new ResizeObserver(sizeSpacer).observe(root); } catch (e) {}
        }
      }

      var lastY = window.pageYOffset;
      var ticking = false;
      function onScroll() {
        var y = window.pageYOffset;
        header.classList.toggle('is-scrolled', y > 6);
        if (sticky && hideOnDown && !isMenuOpen()) {
          if (y > lastY && y > 120) {
            root.classList.add('agh-hide');
          } else if (y < lastY) {
            root.classList.remove('agh-hide');
          }
        }
        lastY = y <= 0 ? 0 : y;
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });
      onScroll();
    }

    /* ---------- Mobile menu ---------- */
    function openMenu() {
      if (!mobile) return;
      mobile.hidden = false;
      if (overlay) overlay.hidden = false;
      window.requestAnimationFrame(function () {
        mobile.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (root) root.classList.remove('agh-hide');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeMenu() {
      if (!mobile) return;
      mobile.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      var done = function () {
        if (!mobile.classList.contains('is-open')) {
          mobile.hidden = true;
          if (overlay) overlay.hidden = true;
        }
        mobile.removeEventListener('transitionend', done);
      };
      mobile.addEventListener('transitionend', done);
    }
    function toggleMenu() { isMenuOpen() ? closeMenu() : openMenu(); }

    if (burger) burger.addEventListener('click', toggleMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isMenuOpen()) closeMenu(); });
    if (mobile) {
      mobile.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) closeMenu();
      });
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth > 990 && isMenuOpen()) closeMenu();
    });

    /* ---------- Mobile sub-menu accordions ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-agh-sub-toggle]'), function (btn) {
      var item = btn.closest('.agh-mobile__item');
      var sub = item ? item.querySelector('.agh-mobile__sub') : null;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (sub) sub.style.maxHeight = open ? '0px' : sub.scrollHeight + 'px';
      });
    });

    /* ---------- Cart opens the theme drawer ---------- */
    var cart = root.querySelector('[data-agh-cart][data-open-drawer="true"]');
    if (cart) {
      cart.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer-component');
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        /* No drawer on the page -> let the link navigate to /cart */
        if (!drawer && !trigger) return;
        e.preventDefault();
        /* 1) Call the component's open() directly — most reliable, and immune to
              isTrusted checks that make synthetic trigger clicks silently no-op. */
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); return; } catch (err) { /* fall through */ }
        }
        /* 2) Fallback: dispatch a real click event on the cart trigger. */
        if (trigger) {
          trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        }
      });
    }

    /* ---------- Keep the cart count fresh ---------- */
    var countEl = root.querySelector('[data-agh-cart-count]');
    if (countEl) {
      var refresh = function () {
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            countEl.textContent = c.item_count;
            countEl.classList.toggle('is-empty', c.item_count === 0);
          })
          .catch(function () {});
      };
      window.addEventListener('pageshow', refresh);
      document.addEventListener('cart:refresh', refresh);
    }

    /* ---------- Announcement rotation ---------- */
    var announce = root.querySelector('[data-agh-announce]');
    if (announce) {
      var msgs = Array.prototype.slice.call(announce.querySelectorAll('.agh-announce__msg'));
      if (msgs.length > 1) {
        var idx = 0, timer = null;
        var interval = parseInt(announce.getAttribute('data-interval'), 10) || 5000;
        var autoplay = announce.getAttribute('data-autoplay') !== 'false';
        function show(i) {
          idx = (i + msgs.length) % msgs.length;
          msgs.forEach(function (m, mi) { m.classList.toggle('is-on', mi === idx); });
        }
        function start() { if (autoplay) { stop(); timer = setInterval(function () { show(idx + 1); }, interval); } }
        function stop() { if (timer) clearInterval(timer); }
        var prev = announce.querySelector('[data-agh-announce-prev]');
        var next = announce.querySelector('[data-agh-announce-next]');
        if (prev) prev.addEventListener('click', function () { show(idx - 1); start(); });
        if (next) next.addEventListener('click', function () { show(idx + 1); start(); });
        announce.addEventListener('mouseenter', stop);
        announce.addEventListener('mouseleave', start);
        start();
      }
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-agh-root]'), initHeader);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
